import cart from '@views/cart/cart';
import selectaddress from '@views/cart/selectaddress';
import writeinvoice from '@views/cart/writeinvoice';
import firmorder from '@views/cart/firmorder';
import paysuccess from '@views/cart/paysuccess';
const cartRouter = [{
  path: 'cart',
  name: 'cart',
  // component: cart,
  component: resolve => require(['@views/cart/cart'],resolve),
  meta: {
    title: '购物车',
    id: '3'
  }
}, {
  path: 'selectaddress',
  name: 'selectaddress',
  // component: selectaddress,
  component: resolve => require(['@views/cart/selectaddress'],resolve),
  meta: {
    title: '选择地址',
    requireAuth: true
  }
}, {
  path: 'writeinvoice',
  name: 'writeinvoice',
  // component: writeinvoice,
  component: resolve => require(['@views/cart/writeinvoice'],resolve),
  meta: {
    title: '发票',
    requireAuth: true
  }
}, {
  path: 'firmorder',
  name: 'firmorder',
  // component: firmorder,
  component: resolve => require(['@views/cart/firmorder'],resolve),
  meta: {
    title: '确认订单',
    requireAuth: true
  }
}, {
  path: 'firmpay',
  name: 'firmpay',
  // component: firmorder,
  component: resolve => require(['@views/cart/firmpay'],resolve),
  meta: {
    title: '确认支付',
    requireAuth: true
  }
}, {
  path: 'paysuccess',
  name: 'paysuccess',
  // component: paysuccess,
  component: resolve => require(['@views/cart/paysuccess'],resolve),
  meta: {
    title: '支付成功',
    requireAuth: true
  }
}]

export default cartRouter;



// WEBPACK FOOTER //
// ./src/router/cart/index.js